import { DatePipe } from '@angular/common';
import { Component, ViewChild, ElementRef  } from '@angular/core';
import {TerminalService} from 'src/app/services/terminal.service'
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { FlightService } from 'src/app/services/flight.service';
import {PaymentConfigService}  from 'src/app/services/payment-config.service'

@Component({
  selector: 'app-terminal',
  templateUrl: './terminal.component.html',
  styleUrls: ['./terminal.component.css']
})
export class TerminalComponent {
  @ViewChild('terminal') terminal!: ElementRef;
  terminalItems: { type: string, text: string }[] = [];
  retrive:any
command="";
flightDetails:any=[]
ClassData:any
fareData:any
commandHistory: string[] = [];
output: string = '';
history:any
rtdata:any
getSession:any;
getdataa:any;
RequestData:any
cardNo:any=[]
showPending:boolean=false
constructor(private PaymentConfigService:PaymentConfigService,
  private TerminalService:TerminalService,private location:Location,private FlightService:FlightService,
  private router : Router){
    this.creditList()
  this.retrive='terminal'
}


 executeCommand(event: any) {
    console.log(event.target.value)
    this.output += `${this.command}\n\xa0`;
    sessionStorage.setItem('my_data', this.output);
    const output = this.executeStaticCommand(event.target.value);
    console.log(output);
    
    
    //this.commandHistory.push(this.command);
    this.terminalItems.push({ type: 'command', text: event.target.value });
   // this.terminalItems.push({ type: 'output', text: output });
    
  }
  get(){
    this.history=sessionStorage.getItem('my_data')
    return sessionStorage.getItem('my_data');
  }
  showHistory() {
    this.output += `Command History:\n${this.commandHistory.join('\n')}\n`;
  }
  commandClick(event:any){
    if(event.includes("history")){
      this.get()
      const output = this.history ;
      this.terminalItems.push({ type: 'command', text: event });
      this.terminalItems.push({ type: 'output', text: output });
      } 
       if(event.includes("clear")){
       
        this.terminalItems = [];
      }
      if(event.includes("ticket-issuance")){
       
       this.retrive=event

      }
      if(event.includes("terminal")){
       
        this.retrive=event
 
       }
       if(event.includes("progress")){
       
        this.retrive=event
 
       }
        if(event.includes("flight")){
          window.location.href = "/app/flight"
       }
       if(event.includes("back")){
      this.location.back();
     }
  }
  /*executeStaticCommand(event: string): string {
    // Logic to process the command and return the output
    return `Output for '${event}'`;
  }*/
  executeStaticCommand(command:string){
   
    const pattern = /^TRDC\/TK-\d{10}$/;
    let output = "";
    //const patterns = /^RT\/\d+$/;
    const patterns =/^RT\/[A-Za-z0-9]+$/;
    const FPpatterns =/^FP\/[A-Za-z0-9]+$/;

    const Anpatterns =/^AN[A-Za-z0-9]+$/;
    const SSpatterns =/^SS[A-Za-z0-9]+$/;
    if(pattern.test(command)){

     // output = "SYSTEM RESPONSE: OK - DOCUMENT(S) CANCELLED\n"
      this.command ='';
      setTimeout(() => {
        this.terminalItems.push({ type: 'output', text: "SYSTEM RESPONSE: OK - DOCUMENT(S) CANCELLED\n" });
       
      }, 100);

    }
   
    else if(Anpatterns.test(command)){
     
      this.showPending=true


console.log()
let fromAirport:any
let toAirport:any
let requestDate:any

const regex = /([0-9]{2}[A-Z]{3})/; // This regex captures "10OCT" from the given code
const match = command.match(regex);

if (match) {
  let extractedValue:string |null
  console.log( match)
  extractedValue = match[0];
  console.log(extractedValue)
 let date=new Date(extractedValue)
 const datePipe = new DatePipe('en-US');
 const inputDate = extractedValue;
const year = new Date().getFullYear(); // Get the current year
const formattedDate = datePipe.transform(`${year}-${inputDate}`, 'yyyy-MM-ddTHH:mm:ss.SSSZ');
 console.log(formattedDate)
 requestDate=formattedDate
 
} 
const regexfrom = /([A-Z]{3})/g; // This regex captures "VNS" from the given code
const matchfrom = this.command.match(regexfrom);
if (matchfrom) {
  fromAirport = matchfrom[1];
 toAirport=matchfrom[2];
 
}
let request ={
  "airSearchRequestBaseDetails": [
      {
          "requestedDate":requestDate,
          "requestedClass": 'Y',
          "fromAirport": fromAirport,
          "toAirport": toAirport
      }
     
  ],
  "paxCount":1,
  "adultCount": 1,
  "childCount": 0,
  "infantCount": 0
  
}

console.log(request)

this.FlightService.SearchFlight(request)
.subscribe({
  next : (res) => {
    this.showPending=false

    if(res) { 
      
      let data=res.body
      
     let flightDetail:any=[]

     flightDetail=data
     this.flightDetails=flightDetail
    console.log(flightDetail)
    
     
    
      let flightOutPut:any=[]
    
    console.log(flightDetail[0].flights.length)
    for(let i=0;i<flightDetail[0].flights.length;i++){
      

   flightOutPut.push(`\xa0`+Number(i+1)+`   `+`\xa0`+this.nullCheck(flightDetail[0].flights[i].flightDetailsList[0].carrierName)+`  `+this.nullCheck(flightDetail[0].flights[i].flightDetailsList[0].flightNumber)+`  `
   +this.nullCheck(flightDetail[0].flights[i].flightDetailsList[0].bookingClasses[0].bookingClass)+this.nullCheck(flightDetail[0].flights[i].flightDetailsList[0].bookingClasses[0].seatsAvailability)+`  `
   +this.nullCheck(flightDetail[0].fromAirport)
   +`  `+this.nullCheck(flightDetail[0].toAirport)+` `
   +this.getFormattedArrivalTime(flightDetail[0].flights[i].schDepartureTime)+` `+this.getFormattedArrivalTime(flightDetail[0].flights[i].schArrivalTime)+` `+this.converter(flightDetail[0].flights[i].travelDuration)+`\n\n`)
      console.log(flightOutPut)
           
    }

    const Output= flightOutPut.join("");

    
    
      this.terminalItems.push({ type: 'output', text: Output});
     
    console.log(this.terminalItems)
    

    } else {
      this.terminalItems.push({ type: 'output', text: "Sorry, there are no matching results"});

    } 

  },error : (err) => {
    this.terminalItems.push({ type: 'output', text: "Sorry, there are no matching results"});


    this.showPending=false

    
  }
}
)

 this.command ='';
      // const Output= `--- AMADEUS AVAILABILITY --- \n
     
      // 1. UK 967 J2  C2 D2 T2 Y9  DEL T1 VNS 1  2035 1020 0/320  01:45 `;
     
     
    
    }
    else if(SSpatterns.test(command)){

      const regex = /([0-9]{1}[A-Z]{1}[0-9]{1})/; // This regex captures "10OCT" from the given code
      
      const regexfrom = /([A-Za-z0-9]{1})/g; // This regex captures "VNS" from the given code 
      console.log(this.flightDetails)
      const match = command.match(regexfrom);
      console.log(match)
     let classes:any
     let seatsAvailability:any
     let inList:any=''
     let inList1:any=''
     let inList2:any=''
     let inList3:any=''
      if(match){
        classes=match[3]
        seatsAvailability=match[2]
        if(match[4]){
        inList=match[4]}
        if(match[5]){
        inList1=match[5]}
        if(match[6]){
        inList2=match[6]}
        if(match[7]){
        inList3=match[7]}

       }
       let list=inList+inList1+inList2+inList3
       console.log(list)
      const filteredData = this.flightDetails
      .filter((flight:any) => {
        const bookingClass = flight.flights[list-1]?.flightDetailsList[0]?.bookingClasses[0];
        return bookingClass && bookingClass.bookingClass === classes && bookingClass.seatsAvailability>=seatsAvailability;
      })
      .map((flight:any) => {
        const flightDetails = flight.flights[list-1]?.flightDetailsList;
        return {
          flightDetailsList:flightDetails
        };
      });
      const fareData = this.flightDetails
      .filter((flight:any) => {
        console.log(flight)
        const bookingClass = flight.flights[inList1+inList2+inList3+inList-1]?.flightDetailsList[0]?.bookingClasses[0];
        return bookingClass && bookingClass.bookingClass === classes && bookingClass.seatsAvailability >= seatsAvailability;
      })
      .map((flight:any) => {
        const flightDetails = flight.flights[inList1+inList2+inList3+inList-1]?.fare;
        return {
          flightDetailsList:flightDetails
        };
      });
    
    console.log(filteredData);
   let flightOutPut:any=[]
   for(let i=0;i<filteredData[0].flightDetailsList.length;i++){
    flightOutPut.push(Number(i+1)+`   `+`\xa0`+this.nullCheck(filteredData[0].flightDetailsList[i].carrierName) 
    +` `+this.nullCheck(filteredData[0].flightDetailsList[i].flightNumber)
    +` `+this.nullCheck(filteredData[0].flightDetailsList[i].bookingClasses[0].bookingClass)
    +` `+this.dateEEFormate(filteredData[0].flightDetailsList[i].schDepartureTime)
    +` `+this.convertdatetoNo(filteredData[0].flightDetailsList[i].schDepartureTime)
    +` `+this.nullCheck(filteredData[0].flightDetailsList[i].fromAirport)
    +this.nullCheck(filteredData[0].flightDetailsList[i].toAirport)
    +` `+this.nullCheck('HK1')
    +` `+this.getFormattedArrivalTime(filteredData[0].flightDetailsList[i].schDepartureTime)
    +` `+this.getFormattedArrivalTime(filteredData[0].flightDetailsList[i].schArrivalTime)
    +` `+this.dateEEFormate(filteredData[0].flightDetailsList[i].schArrivalTime)
    +` `+this.nullCheck('E')
    +` `+this.nullCheck(filteredData[0].flightDetailsList[i].carrierPlaneCode)+`\n\n`)
    }
    this.fareData=fareData
      
    this.ClassData=filteredData
    const Output=flightOutPut.join("");

    this.command ='';

     setTimeout(() => {
       this.terminalItems.push({ type: 'output', text: Output });
     
    }, 100);
          }
          else if(command==="CARD"){
            this.showPending=true

            this.command='';
         let data:any=[]
         let Output:any
         if(this.CreditData.length===0|| !this.CreditData){
          Output="Card not found"
          this.showPending=false

         }else{
          this.showPending=false

          console.log(this.CreditData ) 
          for(let i=0 ;i< this.CreditData.length;i++){
            data.push(Number(i+1)+`  `+this.CreditData[i].maskedCardNumber+'\n')
console.log(data)
Output=data.join(' ')

          }
         }
          
            
            console.log(Output)
            
            setTimeout(() => {
              this.terminalItems.push({ type: 'output', text: Output });
            
           }, 100);
          
          }
          else if(command==="FXX"){

            console.log(this.fareData)
            console.log(this.ClassData)

          let fare:any=[]
          fare.push(`***** FARE BASIS          FARE           CLASS ***`+`\n\n`)
          for(let i=0;i<this.ClassData[0].flightDetailsList.length;i++){

            
            fare.push(`  `+`\xa0`+Number(i+1)+`      `+this.nullCheck(this.ClassData[0].flightDetailsList[i].bookingClasses[0].fareBasis)+`          `+this.nullCheck(this.fareData[0].flightDetailsList[0].baseFare)+`           `+this.nullCheck(this.ClassData[0].flightDetailsList[i].bookingClasses[0].bookingClass)+`\xa0`+`\n\n`)
          
          }
            const Output=fare.join("");
            this.command ='';

             setTimeout(() => {
               this.terminalItems.push({ type: 'output', text: Output });
             
            }, 100);
          }
else if(FPpatterns.test(command)){
  let cardNo:any
  cardNo=command.split('/')[1]
  if(cardNo==="CA"){
    this.updateFOPPnr(cardNo)

  }else{
  for(let i=0 ;i< this.CreditData.length;i++){
   
this.cardNo.push(this.CreditData[i].maskedCardNumber)

  }
  
   let card=this.cardNo[cardNo-1]
   this.updateFOPPnr(card)
  }
  
this.command=''
}else if(command==='TTP'){
  this.docIssuance()
  this.command=''

}
    else if(patterns.test(command)){
     console.log(patterns.test(command))  
     let rtCommand=command.split('/')
     console.log(rtCommand)
     this.pnrNo=rtCommand[1]
      this.getPnr(rtCommand[1]);
      console.log(this.rtdata);
       // this.terminalItems.push({ type: 'command', text: this.command });
     // this.terminalItems.push({ type: 'output', text: this.rtdata});
      //this.getdata()
      this.command ='';
    }
    // else if(command.includes("TTP")){
    //   this.getSessions();
    //  // console.log(this.getSession.split("/ETUK/INR32858/31JUL23/DELVS319B/14363904")[0].split("PAX 228-")[1])

    //  // output = `Ticket No `+this.getSession.split("/ETUK/INR32858/31JUL23/DELVS319B/14363904")[0].split("PAX 228-")[1]+`\xa0`+"ISSUED SUCCESSFULLY\n"
    //  this.command ='';
    //  setTimeout(() => {
    //  this.terminalItems.push({ type: 'output', text:(this.getSession.split("/ETUK/INR32858/31JUL23/DELVS319B/14363904")[0]?.split("PAX 228-")[1]?(`Ticket No `+this.getSession.split("/ETUK/INR32858/31JUL23/DELVS319B/14363904")[0]?.split("PAX 228-")[1]+`\xa0`+"ISSUED SUCCESSFULLY\n"):"No record found")});
    // }, 100);
    // }
    else if(command.includes("YRT")){
     const Output = `--- TST RLR SFP ---
      RP/LONU126HJ/LONU126HJ   DL/RM 27APR21/2336Z 2QYWGC
      NYC1S2417/0004HS27AOR21 
      1.BELGRAVE/KINIA   2.PARRIS/MICHAEL 
      3.DL1094 E 28MAY 5 LGAMCO HK2 0705 0953 28MAY E DL/HMZOCY
      4.DL 555 E 31MAY 1 MCOLGA HK2 0600 0839 31MAY EMAY E DL/HMZOCY
      5.AP B`;
     // output = Output

     this.command ='';
     setTimeout(() => {
     this.terminalItems.push({ type: 'output', text: Output});
    }, 100);
    }
    else{
      setTimeout(() => {
      this.terminalItems.push({ type: 'output', text: "Command not found \n"});
      //output = "PNR not found \n"
    }, 100);
      this.command ='';
    }
    return output
  }
  
  focusTerminal() {
    this.terminal.nativeElement.focus();
  }
  fopAmt:any

   getPnr(command:any){
      // this.chargerConector.push({tab:this.responseWait});
      this.showPending=true

        
       this.TerminalService
       .getmopnr(command)
       .subscribe({
         next : (res:any) => {
          console.log(res)
          let data=res
          this.fopAmt = data?.result?.pnrData.dataElement.fareDetails.totalAmt

          this.getResult(data?.result?.pnrData)
          this.showPending=false
         },error : (err) => {
          
          this.showPending=false
          this.terminalItems.push({ type: 'output', text: "PNR not found \n"});

         }
       }
     )
     }
   
  
     getResult(data:any){
      let result:any =""
      console.log(data)
    if(data?.passengerDetails===undefined){
     // console.log(data.result.passengers)
      this.rtdata="PNR not found \n"
     
      this.terminalItems.push({ type: 'output', text: this.rtdata});
     // sessionStorage.setItem('data',  this.rtdata);
    }else{
     
      console.log(data)
      sessionStorage.setItem('_data', data);
     const dataElement=this.ELEMENT(data.dataElement.dataElementSSR,data.dataElement.dataElementOther)
    console.log(data.passengerDetails)
      const passengerInfo = this.getPassengers(data.passengerDetails);
      console.log(passengerInfo.length)
      let passengerCount = passengerInfo.length;
      console.log(passengerCount);
      let counter = passengerCount;
     
      /*const airInfo = this.getAirInfo(data.result);
      let airinfoCount = airInfo.split("\n").length;
      console.log(airinfoCount)
      const ssrInfo = this.getSSR(data.result);
      console.log(ssrInfo)
      let ssrInfoCount = ssrInfo.split("\n").length;
      let counter = passengerCount+airinfoCount+ssrInfoCount*/
      result =data.longFreeText+"\n"+
      `\xa0`+"RP/"+"DELVS319B/DELVS319B"+`\xa0\xa0\xa0\xa0\xa0\xa0`+`DL/SU`+`\xa0\xa0`+(data?.result?.fullDetail?.split('/')[3] ? data?.result?.fullDetail?.split('/')[3]:"")+`\xa0\xa0`+(data.pnrNumber?(data.pnrNumber+"\n"):""+"\n")+
     // `\xa0`+"1"+`\xa0`+data.result?.passengers[0].lastName+`|`+data.result?.passengers[0].firstName+`|`+data.result?.passengers[0].Title+`\n`+
     // `\xa0`+"2"+`\xa0`+data.result?.airInfo[0].m_carrierCode+data.result?.airInfo[0].m_flightNumber+`\xa0\xa0`+data.result?.airInfo[0].m_bookingClass+`\xa0\xa0`+data.result?.airInfo[0].departureTime?.split('T')[0]+`\xa0\xa0`+data.result?.airInfo[0].m_departureAirport+data.result?.airInfo[0].m_arrivalAirport+`\xa0\xa0`+data.result?.airInfo[0].m_status+`\xa0\xa0`+data.result?.airInfo[0].m_departureTime?.split("T")[1]?.split(":00.000+00:00")[0]+`\xa0\xa0`+data.result?.airInfo[0].m_arrivalTime?.split("T")[1]?.split(":00.000+00:00")[0]+`\xa0\xa0`+data.result?.airInfo[0].departureTime?.split('T')[0]+`\xa0\xa0`+data.result?.airInfo[0].m_ticketType+`\n`+
     passengerInfo+`\n`+
     dataElement+`\n`;
    // dataElementOther+`\n`+
    // airInfo+`\n`+
    // ssrInfo+`\n`+
      // (data.mobile ? (`\xa0`+ counter++  +`\xa0 `+"AP\xa0") : "")+(data.mobile ? (data.mobile+`/`) : "")+(data.mobile? (data.email+`\n`) :"")+
      // (data.result?.formOfPayment?(`\xa0`+ counter++  +`\xa0`+"FP\xa0"):"")+(data.result?.formOfPayment?(data.result?.formOfPayment+`\n`):"")+
      // (data.result?.fullDetail?(`\xa0`+counter++  +`\xa0`+"FA\xa0"):"")+ (data.result?.fullDetail?(data.result?.fullDetail+`\n`):"")+
      // (data.result?.endorsementValuesMap[15]?(`\xa0`+counter++  +`\xa0`+"FE\xa0"):"" )+(data.result?.endorsementValuesMap[15]?(data.result?.endorsementValuesMap[15]+`\n`):"" )+
      // (data.result?.m_fvToValueMap.FV?(`\xa0`+counter++  +`\xa0`+"FV\xa0"):"")+(data.result?.m_fvToValueMap.FV?( data.result?.m_fvToValueMap.FV+`\n`):"");

        //this.rtdata=result;
      //sessionStorage.setItem('data',  this.rtdata);
     // console.log(result)
      this.terminalItems.push({ type: 'output', text: result});
     


  }  
   
     }

     getPassengers(passengerData:any){
        console.log(passengerData);
      let passengerInfoArr=[];
      for (let i=0;i<passengerData.length;i++){
        passengerInfoArr.push(`\xa0`+`\xa0`+passengerData[i].lastName+`|`+passengerData[i].firstName+`|`+passengerData[i].passengerTitle)
      
      }
      let passengerInfo = passengerInfoArr.join("\xa0");
      return passengerInfo
     }
    
   ELEMENT(dataElementSSR:any,dataElementOther:any){
    this.filterOtherDAta(dataElementOther)
    let elementData:any=[]
     const mergeElement= dataElementSSR.concat(dataElementOther);
      for (let i=0;i<mergeElement.length;i++){

      elementData.push(Number(i+1)+`\xa0`+`\xa0`+mergeElement[i]+`\n`)
      }
    console.log(elementData)
    let passengerInfo = elementData.join("");
    return passengerInfo
   }
     filterOtherDAta(items:any){
      console.log(this.fopAmt)

      for (let i=0;i< items.length;i++) {
        console.log(items[i])

        if (items[i].startsWith("FP CC") || items[i].startsWith("FP CASH")) {
          
          console.log(items[i])

          items[i]= items[i]+"/INR"+this.fopAmt;
        }
       // return items
      }
     // return items;
    
     }
     getAirInfo(allData:any){
      let passengerData = allData.passengerDetails
      console.log(passengerData.length)
      let airInfoCounter = passengerData.length;
      console.log(airInfoCounter)
      let airInfoArr = [];
      let airInfoData = allData.airInfo
       for (let i=0;i<airInfoData.length;i++){ 
          if (airInfoData[i].m_check_in_time && airInfoData[i].m_check_in_time!=""){
           airInfoCounter++
           airInfoArr.push(`\xa0`+airInfoCounter +`\xa0`+`\xa0`+airInfoData[i].m_carrierCode+airInfoData[i].m_flightNumber+`\xa0\xa0`+airInfoData[i].m_bookingClass+`\xa0\xa0`+this.formatDate(airInfoData[i].departureTime?.split('T')[0])+`\xa0\xa0`+airInfoData[i].m_weekDay+`\xa0\xa0`+airInfoData[i].m_departureAirport+airInfoData[i].m_arrivalAirport+`\xa0\xa0`+airInfoData[i].m_status+`\xa0\xa0`+airInfoData[i].m_departureTime?.split("T")[1]?.split(":00.000+00:00")[0]+`\xa0\xa0`+airInfoData[i].m_arrivalTime?.split("T")[1]?.split(":00.000+00:00")[0]+`\xa0\xa0`+this.formatDate(airInfoData[i].departureTime?.split('T')[0])+`\xa0\xa0`+airInfoData[i].m_ticketType)
          }
      }

      console.log(airInfoCounter)
      let airInfo = airInfoArr.join("\n")
      return airInfo 
     }

     getSSR(allData:any){
      let passengerData = allData.passengers 
      console.log(passengerData.length)
      
      
      let airInfoData = this.getAirInfo(allData).split("\n")
      let ssrCounter = passengerData.length+airInfoData.length;
      console.log(ssrCounter)
      let ssrData = allData.m_SSRDataElements
      let ssrDataArr=[];

      for (let i=0;i<ssrData.length;i++){ 
        const cssrCmpanyId = ssrData[i].companyId?ssrData[i].companyId+`|`:"";
        const cssrfreeText=ssrData[i].freeText?ssrData[i].freeText+`|`:"";
        const cssQuantity=ssrData[i].quantity?ssrData[i].quantity+`|`:"";
        const cssrStatus=ssrData[i].status?ssrData[i].status+`|`:"";
        const cssrType=ssrData[i].type?ssrData[i].type:"";
        ssrCounter++
        if(cssrCmpanyId!="" ||cssrfreeText!=""||cssQuantity!=""||cssrStatus!=""||cssrType!=""){
        ssrDataArr.push(`\xa0`+ssrCounter+`\xa0`+`\xa0`+"SSR"+`\xa0`+`\xa0`+cssrCmpanyId+cssrfreeText+cssQuantity+cssrStatus+cssrType)
      }
      }
      let ssrInfo = ssrDataArr.join("\n");
      return ssrInfo
     }
     getdata(){
      this.getdataa=sessionStorage.getItem('data')
      return sessionStorage.getItem('my_data');
     }
     getSessions(){
      console.log(sessionStorage.getItem('_data'))
      this.getSession=sessionStorage.getItem('_data')
      return sessionStorage.getItem('my_data');
     }

     formatDate(val:Date){
      let value:any = ""
      if(val){
      let datepipe = new DatePipe("en");
      value = datepipe.transform(val, "ddMMM")?.toUpperCase();
      }
      
        return value
      
    }

    searchFlight(request:any) {
    
      
      
       this.FlightService.SearchFlight(request)
         .subscribe({
           next : (res) => {
             if(res) { 
               
               let data=res.body
              let flightDetail:any=[]
              flightDetail=data
             console.log(flightDetail)
             
              
             
               let flightOutPut:any=''
             
             console.log(flightDetail[0].flights.length)
             for(let i=0;i<flightDetail[0].flights.length;i++){
               
             console.log("12345678")
               flightOutPut.push(flightDetail[0].flights[i].flightDetailsList[0].carrierName)
               console.log(flightOutPut)
               flightOutPut="1234"
              
             }
             const Output= `--- AMADEUS AVAILABILITY --- \n
     
      // 1. UK 967 J2  C2 D2 T2 Y9  DEL T1 VNS 1  2035 1020 0/320  01:45 `;
     
             
             
               this.terminalItems.push({ type: 'output', text: Output});
              
             console.log(this.terminalItems)
             
         
             } else {
              
             } 
   
           },error : (err) => {
   
             
           }
         }
       )
     }
     getFormattedArrivalTime(item:any): string | null {
      console.log(item)
      if (item) {
        let convertedValue:any = ""
        
        let datepipe = new DatePipe("en");
        //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
        convertedValue =  datepipe.transform(item, "hh:mm");
        
        return convertedValue;
      }
      return '';
    }
    
    nullCheck(item:any){
      if (item) {

        return item;
      }
      return '';
    }

    dateEEFormate(date:any){
      if (date) {
      const parsedDate = new Date(date);
      const datePipe = new DatePipe('en-US');
      date = datePipe.transform(parsedDate, 'ddMMM');
  return date
}
return '';
  
    }
    convertdatetoNo(date:any){
      if (date) {
      const parsedDate = new Date(date);
      const datePipe = parsedDate.getDay()
      date=datePipe
  return date
}
return '';
  
    }
    converter(item:any){
      const totalMinutes = item ;
      const hours = Math.floor(totalMinutes / 60);
      const remainingMinutes = totalMinutes % 60;
      item=`${hours}h ${remainingMinutes}m`
      return item
    }

    pnrNo:any
    CreditData:any
creditList(){
  this.PaymentConfigService
  .creditCardList()
  .subscribe({
    next : (res:any) => {
      if(res) {

         let data=res
         console.log(data)

     this.CreditData=data
     
      } else {
      
      } 
    },error : (err) => {

    


    }
  }
)
}

updateFOPPnr(card:any){
  this.showPending=true

  // this.chargerConector.push({tab:this.responseWait});
  if(this.pnrNo){
  let pnrAddMultiFOPReq :any;
  
  if(card==="CA"){
    pnrAddMultiFOPReq = {
      "pnrNumber":this.pnrNo,
      "identification":"CA",
      
      "amount":this.fopAmt,
      "currencyCode":"INR"
  }
  }
  else{
    pnrAddMultiFOPReq = {
      "pnrNumber":this.pnrNo,
      "identification":"CC",
     "amount":this.fopAmt,
      "currencyCode":"INR",
      "cardNumber":card
  }
  }  
   
  
  this.TerminalService
   .updateFOPPNR(pnrAddMultiFOPReq)
   .subscribe({
     next : (res:any) => {
console.log(res)
      this.getPnr(this.pnrNo);
     },error : (err) => {
      this.showPending=false

      this.getPnr(this.pnrNo);
     }
    })}
    else{

      setTimeout(() => {
         this.showPending=false

        this.terminalItems.push({ type: 'output', text: "PNR not found \n"});
      }, 100);
    }
   }
   docIssuance(){
    // this.chargerConector.push({tab:this.responseWait});
    this.showPending=true
if(this.pnrNo){
  this.TerminalService
  .docIssaunce(this.pnrNo)
  .subscribe({
    next : (res:any) => {
      console.log(res)
      if(res.freeText.startsWith("OK ETICKET")){
        this.terminalItems.push({ type: 'output', text: res.freeText+'\n'});

     this.getPnr(this.pnrNo);}
     else{
      setTimeout(() => {
        this.showPending=false

       this.terminalItems.push({ type: 'output', text: res.freeText+'\n'});
     }, 100);
     }
    }
    ,error : (err) => {
      this.showPending=false

     this.getPnr(this.pnrNo);
    }
   })
  }else{
    setTimeout(() => {
      this.showPending=false

    this.terminalItems.push({ type: 'output', text: "PNR not found \n"});
  }, 100);
  }
}

    
}
